import React, { FunctionComponent, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import BodyFont from '../../../Theme/Fonts/Body'
import { TaboolaRegionItem } from '../../TeaserInterface'
import LinkProps from '../../../Link/LinkProps'
import PodcastShowTeaserImage from './Image'

export type PodcastShowTeaserProps = TestID & {
    /** hides the icon on the bottom left */
    hideIcon?: boolean
    /** the url of the image */
    imageUrl: string
    /** info for seo about imageUrl */
    alt?: string
    /** the headline text which is displayed under the image */
    headlineText: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /** callback when the user presses on the teaser
     *
     * @TJS-type function
     */
    onPress?: () => void
} & LinkProps &
    TaboolaRegionItem

const PodcastShowTeaser: FunctionComponent<PodcastShowTeaserProps> = ({
    hideIcon,
    imageUrl,
    alt,
    headlineText,
    href,
    onPress,
    testID,
    webTBRegionItem,
    webRel,
}): ReactElement | null => {
    return (
        <Touchable
            onPress={onPress}
            href={href}
            testID={testID}
            webTBRegionItem={webTBRegionItem}
            webRel={webRel}
        >
            <Grid noExpand width={125}>
                <PodcastShowTeaserImage imageUrl={imageUrl} alt={alt} hideIcon={hideIcon} />
                <Grid noExpand marginTop={5} marginBottom={1}>
                    <BodyFont
                        color="onyx-5"
                        numberOfLines={2}
                        bold
                        textAlign="center"
                        className={webTBRegionItem === '' ? 's1-taboola-title' : undefined}
                    >
                        {headlineText}
                    </BodyFont>
                </Grid>
            </Grid>
        </Touchable>
    )
}

export default PodcastShowTeaser
